import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import ISODirectoryComponent from './ISODirectoryComponent';

import './ISO360.css';

function ISO360Directory() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>ISO360 - Search</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
          <ISODirectoryComponent />
        </div>
      </div>
    </MainLayout>
  );
}

export default ISO360Directory;
